/* global $ */
import { settingsToQueryString } from '../../app/bento-components/video-list/video-utils';

export function getVideos(API, settings, showLoading = () => {}) {
    showLoading();

    return $.ajax({
        method: 'GET',
        url: `${API.MEDIA_MANAGER_ASSETS}${settingsToQueryString(settings)}`,
        type: 'json',
        cache: false
    });
}
